const submenuItems = [
  {
    header: 'Types of Disability Insurance',
    items: [
      { title: 'Long-Term Disability Insurance', url: '/disability-insurance/', },
      { title: 'Short-Term Disability Insurance', url: '/disability-insurance/learn/short-term-disability-insurance/', },
      { title: 'Supplemental Disability Insurance', url: '/disability-insurance/learn/supplemental-disability-insurance/', },
      { title: 'Mortgage Disability Insurance', url: '/disability-insurance/learn/mortgage-disability-insurance/', },
    ],
  },
  {
    header: 'Helpful Resources',
    items: [
      { title: 'Disability Insurance Learn Center', url: '/disability-insurance/learn/', },
      { title: 'How Does Long-Term Disability Insurance Work?', url: '/disability-insurance/learn/how-does-long-term-disability-insurance-work/', },
      { title: 'How Much Does Long-Term Disability Insurance Cost?', url: '/disability-insurance/learn/how-much-does-long-term-disability-insurance-cost/', },
      { title: 'Disability Insurance Features & Riders', url: '/disability-insurance/learn/disability-insurance-riders/', },
    ],
  },
  {
    header: 'Disability Insurance Company Reviews',
    items: [
      { title: 'Mutual of Omaha', url: '/disability-insurance/companies/mutual-of-omaha/', },
      { title: 'Principal', url: '/disability-insurance/companies/principal/', },
      { title: 'MassMutual', url: '/disability-insurance/companies/massmutual/', },
      { title: 'Ameritas', url: '/disability-insurance/companies/ameritas/', },
      { title: 'Guardian', url: '/disability-insurance/companies/guardian-berkshire/', },
      { title: 'The Standard', url: '/disability-insurance/companies/the-standard/', },
      { title: 'Assurity', url: '/disability-insurance/companies/assurity/', },
    ],
  },

];

export default {
  menu: {
    header: 'Disability Insurance',
    shortHeader: 'Disability',
    link: '/disability-insurance/',
    activeName: 'disability-insurance',
    columns: 3,
  },
  intro: {
    cta: 'Get a Free Quote',
    icon: 'disabilityColor3X',
    linkHref: '/disability-insurance/',
    secondaryLinkHref: '/disability-insurance/learn/',
  },
  list: {
    key: 'disability-submenu-list-',
    items: submenuItems,
    type: 'links',
  }
};



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/products/disabilityData.js